import { getProblemById, getFileSuffixByLanguageID} from "../Data/ProblemsMethod";


//To lazy to change variable names, was copied from FetchMainCode
export default async function FetchSolutionCode(ProblemID, LanguageID){
    const currProblem =  getProblemById(ProblemID)
    const pathToCodeFolder = currProblem.path_to_code_folder;
    const FileNameLessLanguageSuffix = currProblem.problem_name.split(' ').join('') + "Solution"; // As a rule, main code file name must match problem name + "Main"
    const fileSuffix = getFileSuffixByLanguageID(LanguageID);
    const mainCodeFileName = FileNameLessLanguageSuffix + fileSuffix;
    const pathToMainCode = pathToCodeFolder + mainCodeFileName;
    console.log("pathToMainCode", pathToMainCode)
    const mainCodeFetch = await fetch(pathToMainCode);
    const SolutionCode = await mainCodeFetch.text();
    console.log("SolutionCode", SolutionCode)
    return SolutionCode;
}